"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apollo_client_1 = require("apollo-client");

var auth_1 = require("../auth");

var mutations_1 = require("../mutations");

var queries_1 = require("../queries");

var utils_1 = require("../utils");

var consts_1 = require("../consts");

var handleDataErrors = function handleDataErrors(mapFn, data, apolloErrors) {
  // INFO: user input errors will be moved to graphql errors
  var userInputErrors = utils_1.getErrorsFromData(data);
  var errors = apolloErrors || userInputErrors ? new apollo_client_1.ApolloError({
    extraInfo: userInputErrors,
    graphQLErrors: apolloErrors
  }) : null;

  if (errors && utils_1.isDataEmpty(data)) {
    return {
      errors: errors
    };
  }

  var result = utils_1.getMappedData(mapFn, data);
  return {
    data: result
  };
};

var APIProxy = /*#__PURE__*/function () {
  function APIProxy(client) {
    var _this = this;

    _classCallCheck(this, APIProxy);

    this.getAttributes = this.watchQuery(queries_1.QUERIES.Attributes, function (data) {
      return data.attributes;
    });
    this.getOrdersByUser = this.watchQuery(queries_1.QUERIES.OrdersByUser, function (data) {
      return data.me ? data.me.orders : null;
    });

    this.getOrderDetails = function (variables, options) {
      if (_this.isLoggedIn()) {
        return _this.watchQuery(queries_1.QUERIES.OrderDetailsByUser, function (data) {
          return data.orderByToken;
        })(variables, options);
      }

      return _this.watchQuery(queries_1.QUERIES.OrderDetails, function (data) {
        return data.orderByToken;
      })(variables, options);
    };

    this.getVariantsProducts = this.watchQuery(queries_1.QUERIES.VariantsProducts, function (data) {
      return data.productVariants;
    });
    this.getShopDetails = this.watchQuery(queries_1.QUERIES.GetShopDetails, function (data) {
      return data;
    });
    this.setUserDefaultAddress = this.fireQuery(mutations_1.MUTATIONS.AddressTypeUpdate, function (data) {
      return data.accountSetDefaultAddress;
    });
    this.setDeleteUserAddress = this.fireQuery(mutations_1.MUTATIONS.DeleteUserAddress, function (data) {
      return data.accountAddressDelete;
    });
    this.setCreateUserAddress = this.fireQuery(mutations_1.MUTATIONS.CreateUserAddress, function (data) {
      return data.accountAddressCreate;
    });
    this.setUpdateuserAddress = this.fireQuery(mutations_1.MUTATIONS.UpdateUserAddress, function (data) {
      return data.accountAddressUpdate;
    });
    this.setAccountUpdate = this.fireQuery(mutations_1.MUTATIONS.AccountUpdate, function (data) {
      return data.accountUpdate;
    });

    this.setPassword = function (variables, options) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result, _result, data;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = null;
                _context.next = 3;
                return this.fireQuery(mutations_1.MUTATIONS.SetPassword, function (data) {
                  return data;
                })(variables, Object.assign(Object.assign({}, options), {
                  fetchPolicy: "no-cache"
                }));

              case 3:
                result = _context.sent;
                _result = result, data = _result.data;
                return _context.abrupt("return", {
                  data: data,
                  error: null
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    this.setPasswordChange = function (variables, options) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, _result2, data;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = null;
                _context2.next = 3;
                return this.fireQuery(mutations_1.MUTATIONS.PasswordChange, function (data) {
                  return data;
                })(variables, Object.assign(Object.assign({}, options), {
                  fetchPolicy: "no-cache"
                }));

              case 3:
                result = _context2.sent;
                _result2 = result, data = _result2.data;
                return _context2.abrupt("return", {
                  data: data,
                  error: null
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    this.attachAuthListener = function (callback) {
      var eventHandler = function eventHandler() {
        callback(_this.isLoggedIn());
      };

      if (consts_1.WINDOW_EXISTS) {
        window.addEventListener("auth", eventHandler);
      }

      return function () {
        if (consts_1.WINDOW_EXISTS) {
          window.removeEventListener("auth", eventHandler);
        }
      };
    };

    this.isLoggedIn = function () {
      return !!auth_1.getAuthToken();
    };

    this.client = client;
  }

  _createClass(APIProxy, [{
    key: "watchQuery",
    value: function watchQuery(query, mapFn) {
      var _this2 = this;

      return function (variables, options) {
        var onComplete = options.onComplete,
            onError = options.onError,
            onUpdate = options.onUpdate,
            apolloClientOptions = __rest(options, ["onComplete", "onError", "onUpdate"]);

        var observable = query(_this2.client, Object.assign(Object.assign({}, apolloClientOptions), {
          variables: variables
        }));

        if (options.skip) {
          return {
            refetch: function refetch() {
              return new Promise(function (resolve) {
                resolve({
                  data: null
                });
              });
            },
            unsubscribe: null
          };
        }

        var subscription = observable.subscribe(function (result) {
          var data = result.data,
              apolloErrors = result.errors,
              loading = result.loading;
          var errorHandledData = handleDataErrors(mapFn, data, apolloErrors);

          if (onUpdate) {
            if (errorHandledData.errors) {
              if (onError) {
                onError(errorHandledData.errors);
              }
            } else {
              onUpdate(errorHandledData.data, loading);

              if (onComplete) {
                onComplete();
              }
            }
          }
        }, function (error) {
          if (onError) {
            onError(error);
          }
        });
        return {
          loadMore: function loadMore(extraVariables) {
            var mergeResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            observable.fetchMore({
              updateQuery: function updateQuery(previousResult, _ref) {
                var fetchMoreResult = _ref.fetchMoreResult;

                if (!fetchMoreResult) {
                  // returning previousResult doesn't trigger observable `next`
                  onUpdate(mapFn(previousResult));
                  return previousResult;
                }

                if (mergeResults) {
                  var prevResultRef = mapFn(previousResult);
                  var newResultRef = mapFn(fetchMoreResult);

                  if (!prevResultRef || !newResultRef) {
                    onUpdate(prevResultRef);
                    return previousResult;
                  }

                  var mergedEdges = utils_1.mergeEdges(prevResultRef.edges, newResultRef.edges); // use new result for metadata and mutate existing data

                  Object.keys(prevResultRef).forEach(function (key) {
                    prevResultRef[key] = newResultRef[key];
                  });
                  prevResultRef.edges = mergedEdges;
                  return previousResult;
                }

                return fetchMoreResult;
              },
              variables: Object.assign(Object.assign({}, variables), extraVariables)
            });
          },
          refetch: function refetch(newVariables) {
            if (newVariables) {
              observable.setVariables(newVariables);
              var cachedResult = observable.currentResult();
              var errorHandledData = handleDataErrors(mapFn, cachedResult.data);

              if (errorHandledData.data) {
                onUpdate(errorHandledData.data);
              }
            }

            return APIProxy.firePromise(function () {
              return observable.refetch(newVariables);
            }, mapFn);
          },
          setOptions: function setOptions(newOptions) {
            return APIProxy.firePromise(function () {
              return observable.setOptions(newOptions);
            }, mapFn);
          },
          unsubscribe: subscription.unsubscribe.bind(subscription)
        };
      };
    }
  }, {
    key: "fireQuery",
    value: function fireQuery(query, mapFn) {
      var _this3 = this;

      return function (variables, options) {
        return APIProxy.firePromise(function () {
          return query(_this3.client, Object.assign(Object.assign({}, options), {
            variables: variables
          }));
        }, mapFn);
      };
    } // Promise wrapper to catch errors

  }], [{
    key: "firePromise",
    value: function firePromise(promise, mapFn) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var _yield$promise, data, apolloErrors, errorHandledData;

          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return promise();

                case 3:
                  _yield$promise = _context3.sent;
                  data = _yield$promise.data;
                  apolloErrors = _yield$promise.errors;
                  errorHandledData = handleDataErrors(mapFn, data, apolloErrors);

                  if (errorHandledData.errors) {
                    reject(errorHandledData.errors);
                  }

                  resolve({
                    data: errorHandledData.data
                  });
                  _context3.next = 14;
                  break;

                case 11:
                  _context3.prev = 11;
                  _context3.t0 = _context3["catch"](0);
                  reject(_context3.t0);

                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 11]]);
        }));
      });
    }
  }]);

  return APIProxy;
}();

exports.default = APIProxy;